export const ERROR_CODE = {
    NO_ERROR: "no_error",
    REQUEST_OUTSTANDING: "request_outstanding",
    UNKNOWN_USER: "unknown_user",
    UNAUTHORISED_ACCESS: "unauthorised_access",
    EMPTY_RESPONSE: "empty_response",
    UNKNOWN_URL: "unknown_url",
    SERVER_ERROR: "server_error",
  };